function historyBack () {
  if (typeof window === 'undefined') return
  window.history.back()
}

module.exports = { historyBack }
